import {
  Beer,
  UtensilsCrossed,
  Coffee,
  IceCreamCone,
  Landmark,
  Bath,
  Bike,
  Mountain,
} from "lucide-react";

export const IMAGES = {
  heroHome: "/images/home-hero-coastal.jpg",
  heroRiders: "/images/bike-path-riders.jpg",
  heroBusinesses:
    "https://images.unsplash.com/photo-1584225065152-4a1454aa3d4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  heroRental:
    "https://images.unsplash.com/photo-1758837923895-2a609cad969e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  heroAbout:
    "https://images.unsplash.com/photo-1768347441981-fb1255ca7101?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  cafe: "https://images.unsplash.com/photo-1559305616-3f99cd43e353?q=85&w=1200",
  rentalWorkshop: "/images/rental-shop-counter.jpg",
};

export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-link-home" },
  { to: "/riders", label: "Riders", testid: "nav-link-riders" },
  { to: "/businesses", label: "Businesses", testid: "nav-link-businesses" },
  { to: "/partners", label: "Partners", testid: "nav-link-rental-shops" },
  { to: "/about", label: "About", testid: "nav-link-about" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

export const CATEGORIES = [
  { id: "breweries", label: "Breweries", icon: Beer, color: "#E05A47" },
  { id: "restaurants", label: "Restaurants", icon: UtensilsCrossed, color: "#2D6A4F" },
  { id: "cafes", label: "Cafés", icon: Coffee, color: "#38A3A5" },
  { id: "icecream", label: "Ice Cream", icon: IceCreamCone, color: "#E0894A" },
  { id: "attractions", label: "Attractions", icon: Landmark, color: "#154234" },
  { id: "bathrooms", label: "Bathrooms", icon: Bath, color: "#52635B" },
];

export const PARTNERS = [
  {
    id: "bristol-bikes",
    name: "Bristol Bikes",
    tag: "Bristol, RI",
    color: "#16294F",
    colors: ["#16294F", "#2FB7E8"],
    logo: "/partners/bristol-bikes.png",
    url: "https://bristolbikes.com",
  },
  {
    id: "roots-branches",
    name: "Roots & Branches",
    tag: "Garden shop · Est. 1998",
    color: "#2E5D34",
    logo: "/partners/roots-branches.png",
    url: "https://www.therootsandbranches.com",
  },
];

export const categoryById = (id) => CATEGORIES.find((c) => c.id === id);

export const STOPS = [
  {
    id: 1,
    name: "Fern Hollow Brewing",
    cat: "breweries",
    x: 24,
    y: 35,
    blurb: "Small-batch ales, bike racks out front, and a patio facing the river trail.",
    tag: "Rider deal — $1 off pints",
  },
  {
    id: 2,
    name: "Switchback Café",
    cat: "cafes",
    x: 46,
    y: 64,
    blurb: "Espresso, fresh pastries, and free water-bottle refills for anyone on two wheels.",
    tag: "Opens 6 AM daily",
  },
  {
    id: 3,
    name: "The Spoke & Skillet",
    cat: "restaurants",
    x: 58,
    y: 48,
    blurb: "Farm-table brunch two minutes off the greenway. Worth every pedal stroke.",
    tag: "Weekend brunch",
  },
  {
    id: 4,
    name: "Bluebird Scoops",
    cat: "icecream",
    x: 84,
    y: 48,
    blurb: "Rotating small-batch flavors. The unofficial post-ride tradition.",
    tag: "Seasonal — maple trail crunch",
  },
  {
    id: 5,
    name: "Old Mill Overlook",
    cat: "attractions",
    x: 12,
    y: 58,
    blurb: "Historic mill site with river views, interpretive signs, and picnic tables.",
    tag: "Free entry",
  },
  {
    id: 6,
    name: "Trailhead Rest Stop",
    cat: "bathrooms",
    x: 70,
    y: 29,
    blurb: "Clean public restrooms, a water station, and a repair stand at mile 4.",
    tag: "Open 24/7",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Curated, never cluttered",
    body: "We don't mirror every pin on the internet. VeloPaths shows only approved local stops — the ones actually worth a detour.",
  },
  {
    n: "02",
    title: "Local first, always",
    body: "Every brewery, café, and scoop shop on the map is a real neighborhood business, vetted by people who ride the route.",
  },
  {
    n: "03",
    title: "Built for the saddle",
    body: "Glanceable cards, one-thumb controls, and routes that respect your momentum. The app works at fifteen miles per hour.",
  },
  {
    n: "04",
    title: "A platform that grows",
    body: "Each partner that joins brings their town, their trails, and their flavor — a network that scales community by community.",
  },
];

